import React from "react";
import {
	View,
	StyleSheet
} from "react-native";

import Style from "ae-style";

var styles = StyleSheet.create({
	container: {
		marginVertical: Style.layout.marginContentSmall
	},
	stretch: {
		flex: 1
	},
});

export default function InputContainer(props) {
	var inline = props.inline; var stretch = props.stretch;
	var style = [styles.container];
	if (inline) {
		style = null;
	} else{
		if (stretch)
			style.push(styles.stretch);
		if(props.style)
			style.push(props.style);
	}

	return (
		<View style={style}>
			{props.children}
		</View>
	);
}
